export const getCurrentFinancialYear = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  if (month >= 5) {
    return new Date(year, 0);
  } else {
    return new Date(year - 1, 0);
  }
};

export const formatYear = (dateObj) => {
  const startYear = dateObj.getFullYear();
  const endYear = startYear + 1;
  return `${startYear}-${endYear.toString().slice(-2)}`;
};
